import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

Vue.use(Vuex);

export default function createStore() {
  return new Vuex.Store({
    state: {
      jobs: [],
      cities: [],
      project: {
        current: {},
      },
      instagram_post: [],
    },
    actions,
    mutations,
    getters,
  });
}



// WEBPACK FOOTER //
// ./src/store/index.js